import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';

//services
import { HttpTestService } from '../../services/http.service';
import { sessionServices } from '../../services/session.services';
import { Router, NavigationEnd } from '@angular/router';


@Component({
  selector: 'app-dashboard-cat',
  templateUrl: './dashBoardCategory.component.html'
})
export class dashboardCatComponent implements OnInit {

  //variable deceleration
  public errorMsg : string = "";
  public successMsg : string = "";
  public sessionData : any;
  @ViewChild('dashboardmenu') private dashboardmenu: ElementRef;

  constructor(public http: HttpTestService, public session: sessionServices, private router:Router) { 
	this.router.routeReuseStrategy.shouldReuseRoute=function(){
		return false;
	}
	this.router.events.subscribe((evt) => {
        if (evt instanceof NavigationEnd) {
           // trick the Router into believing it's last link wasn't previously loaded
           this.router.navigated = false;
		   // if you need to scroll back to top, here is the right place
		//    console.log(this.dashboardmenu.nativeElement.clientHeight)
		   setTimeout(() => {
			   window.scrollTo({ top: (this.dashboardmenu.nativeElement.clientHeight + 720), behavior: 'smooth' });
		   }, 1000);
        }
    });
  }

  ngOnInit() {
	  this.getSession();
	}
  
  //get session details
	getSession = function(){
		this.sessionData = this.session.getSessionDetails();
		// console.log("***** SessionDATA***** ",this.sessionData)
	}
  
  //logout function
	logout() {
		window.sessionStorage.setItem('logged-in', 'false');
		window.sessionStorage.setItem('fname', "");
		window.sessionStorage.setItem('lname', "");
		window.sessionStorage.setItem('email', "");
		window.sessionStorage.setItem('id', "");
		window.sessionStorage.setItem('avataar', "");
		self.location.replace('');
	}

	//register
	register(){

	}
}



// WEBPACK FOOTER //
// D:/Aliva/IPCL/IPCL_SELF_CARE/src/app/components/dashboardCategory/dashBoardCategory.component.ts